/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Description_LabelInputs */



/**
* | output |
* | --- |
* | "Issue description" |
*
* @param {Manual_Qc_Description_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_description_label = /** @type {((inputs?: Manual_Qc_Description_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Description_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description de l'incident")
	if (locale === "de") return /** @type {LocalizedString} */ ("Problembeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione del problema")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание проблемы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción del problema")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("问题描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("問題の説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मुद्दे का विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição do problema")
	return /** @type {LocalizedString} */ ("Issue description")
});